import apps from "@services/applications";
export default [
  {
    path: "/app/dashboard",
    name: "dashboard",
    meta: {
      module: "dashboard",
      application: apps.Modules.Cockpit.Id
    },
    component: () => import("@Dashboard/views/Dashboard.vue")
  }
];
